import app from 'flarum/common/app';
import extractText from 'flarum/common/utils/extractText';
import Widget, { type WidgetAttrs } from 'flarum/extensions/afrux-forum-widgets-core/common/components/Widget';

export default class OnlineUsersWidget extends Widget<WidgetAttrs> {
  className() {
    return 'OnlineUsersWidget';
  }

  icon() {
    return 'fas fa-users';
  }

  title() {
    return extractText(app.translator.trans('flarum-online-users-widget.forum.widget.title'));
  }

  content() {
    const onlineUsers = app.forum.attribute('flarumOnlineUsers') as
      | {
          total: number | undefined;
          guests: number;
          members: number;
        }
      | undefined;

    const label = [
      app.translator.trans('flarum-online-users-widget.forum.widget.total_online_label', {
        count: onlineUsers?.total || 0,
      }),
      app.translator.trans('flarum-online-users-widget.forum.widget.split_online_label', {
        guest_count: onlineUsers?.guests || 0,
        member_count: onlineUsers?.members || 0,
      }),
    ]['total' in (onlineUsers || {}) ? 0 : 1];

    return (
      <div className="OnlineUsersWidget-count">
        <span>{label}</span>
      </div>
    );
  }
}
